/* @flow */
import React from 'react';
import { FormattedMessage } from 'react-intl';
import MoreOptionsIcon from 'dibs-vg/dist/react/more-options';
import classNames from 'classnames';

import styles from './styles.scss';

type Props = {|
    +localizedPdpUrl: string,
    hasTopMargin?: boolean,
|};

export function MoreOptionsBadge({ localizedPdpUrl, hasTopMargin }: Props) {
    return (
        <div className={classNames(styles.container, { [styles.hasTopMargin]: hasTopMargin })}>
            <a href={localizedPdpUrl} className={styles.link}>
                <MoreOptionsIcon className={styles.moreOptionsIcon} />
                <FormattedMessage
                    id="dc.searchProductTile.moreOptionsBadge"
                    defaultMessage="More Options"
                />
            </a>
        </div>
    );
}
